"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameAuthType = void 0;
var GameAuthType;
(function (GameAuthType) {
    GameAuthType["JoinRoom"] = "joinRoom";
    GameAuthType["Monitoring"] = "monitoring";
    GameAuthType["StressTesting"] = "stressTesting";
})(GameAuthType || (exports.GameAuthType = GameAuthType = {}));
